import { useContext } from 'react'
import { MeContext } from '../context/context'

export const useAuth = () => {
  const context = useContext(MeContext)
  if (!context) {
    throw new Error('useAuth must be used within a MeProvider')
  }
  return context
}
